const SKELETON_WIDTHS = [65, 80, 45, 70, 55, 82, 38, 76, 50, 88, 42, 68, 60, 75, 35, 85, 52, 78, 48, 62];

export const SlidesLibrarySidebarSkeleton = () => {
  return (
    <div className="tw-animate-skeleton-loading tw-space-y-2 tw-p-3">
      {SKELETON_WIDTHS.map((item) => (
        <div
          className="tw-flex tw-h-[30px] tw-items-center tw-px-3"
          key={item}
        >
          <span
            className="tw-h-[6px] tw-rounded-2xl tw-bg-blue-100"
            style={{ width: `${item}%` }}
          ></span>
        </div>
      ))}
    </div>
  );
};
